import { mpEventInfo } from '@/constant'
import type { DefaultResponse, YearMonthStr } from '@/types'
import maxios from '@/utils/axios/maxios'

const examApi = {
  // 시험지 n명에게 출제하기
  postAssignExamToStudent: (
    examId: res.AssignedExam['id'],
    studentIdList: res.AssignedStudent['studentId'][],
  ) => {
    return maxios.post<DefaultResponse<res.AssignStudentExamEchoResponse>>(
      '/student-exam',
      {
        examId,
        studentIdList,
      },
      {
        params: { mp_event_name: mpEventInfo.학력평가_시험지출제 },
      },
    )
  },
  // 출제 취소하기
  deleteExamStudent: (studentExamIdList: res.AssignedStudent['id'][]) => {
    return maxios.delete('/student-exam', {
      data: studentExamIdList,
      params: {
        mp_event_name: mpEventInfo.학력평가_시험지출제취소,
      },
    })
  },
  // 시험지의 채점 가져오기
  getExamScoring: (examId: res.AssignedExam['id']) => {
    return maxios.get(`/student-exam/scoring?examId=${examId}`, {
      params: { mp_event_name: mpEventInfo.학력평가_시험지채점조회 },
    })
  },

  // 시험지 채점 및 문제 정보 가져오기
  getStudentExamScoringSummary: (
    examId: res.AssignedExam['id'],
    studentExamIds: res.AssignedStudent['id'][],
  ) => {
    return maxios.get<res.ScoringSummary>(`/student-exam/scoring-summary`, {
      params: { examId, studentExamIds },
    })
  },

  // 시험지의 문제, 채점기록 가져오기
  getStudentExamProblems: (examId: res.AssignedExam['id']) => {
    return maxios.get(`exam/${examId}/problem`, {
      params: { mp_event_name: mpEventInfo.학력평가_시험지채점문제조회 },
    })
  },

  // 채점하기
  patchStudentExanScoring: (
    studentExamId: res.GroupStudentExamResult['id'],
    data: res.GroupStudentExamResult['scoringList'],
  ) => {
    return maxios.patch(`student-exam/${studentExamId}/scoring`, data, {
      params: { mp_event_name: mpEventInfo.학력평가_시험지채점 },
    })
  },

  getReport: (
    params:
      | {
          type: 'EXAM'
          examId: res.AssignedExam['id']
        }
      | {
          type: 'STUDENT_EXAM'
          examId: res.AssignedExam['id']
          studentId: res.AssignedStudent['studentId']
        }
      | {
          type: 'EXAM_SCHEDULE'
          yearMonth: string
          examType: res.AssignedExam['examType']
        },
  ) => {
    return maxios.get<common.PresignedFile>(`/exam/download`, {
      params,
    })
  },

  // 시상자 목록 가져오기
  getAwards: (examIds: res.AssignedExam['id'][]) => {
    return maxios.get<DefaultResponse<res.Award[]>>(`/exam/awards`, { params: { examIds } })
  },

  getExamSchedule: (type: res.AssignedExam['examType'] = 'KMM') => {
    return maxios.get<res.ExamSchedule[]>('/exam/schedule', {
      params: { type },
    })
  },

  getExamByYearMonth: (
    yearMonth: YearMonthStr<'-'>,
    type: res.AssignedExam['examType'] = 'KMM',
  ) => {
    return maxios.get<res.ExamByYearMonth[]>(`/exam/by-year-month`, {
      params: { yearMonth, type },
    })
  },

  getExamAwardByYearMonth: (
    yearMonth: YearMonthStr<'-'>,
    type: res.AssignedExam['examType'] = 'KMM',
  ) => {
    return maxios.get<res.ExamAwardByYearMonth[]>(`/exam/award`, {
      params: { yearMonth, type },
    })
  },
}

export default examApi
